<template>
    <div class="sdr-box contact-box">
        <h4>{{ needhelp[getCurrentLocale] }}</h4>
        <p>{{ sideboxhelptext[getCurrentLocale] }}</p>
        <address class="contact-details">
            <span class="contact-phone"><i class="soap-icon-message"></i> Air41</span>
            <br>
            <a href="mailto:info@air41.de" class="contact-email">info@air41.de</a>
        </address>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                needhelp: {
                    en: 'Reservation information:',
                    de: 'Information zur Reservierung:',
                },
                sideboxhelptext: {
                    en: 'Seat reservations and additional services are possible up to 48 Hours days before departure and at the earliest 24 hours after your booking.',
                    de: 'Sitzplatzreservierungen und Zusatzleistungen sind bis 48 Stunden vor Abflug möglich und frühestens 24 Std. nach Ihrer Buchung.',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/sidebar/ContactBox.vue